export const PASSWORD_RULES = [
  { id: "length", label: "Mínimo 6 caracteres", test: (p) => p.length >= 6 },
  { id: "upper", label: "Al menos una mayúscula", test: (p) => /[A-Z]/.test(p) },
  { id: "lower", label: "Al menos una minúscula", test: (p) => /[a-z]/.test(p) },
  { id: "number", label: "Al menos un número", test: (p) => /\d/.test(p) },
  { id: "special", label: "Al menos un carácter especial (!@#$%...)", test: (p) => /[!@#$%^&*()_+\-=[\]{}|;':",./<>?`~]/.test(p) }
];

export const validatePassword = (password) => {
  const results = PASSWORD_RULES.map((r) => ({ ...r, ok: r.test(password) }));
  const allOk = results.every((r) => r.ok);
  return { results, allOk };
};
